import { Link } from 'react-router-dom';
import { comics, categoryLabels } from '@/mocks/comics';

export default function LatestUpdates() {
  const latestComics = [...comics].sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  ).slice(0, 8);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <i className="ri-timer-line text-secondary-600 text-lg"></i>
              <span className="text-xs font-medium text-secondary-600 bg-secondary-100 px-2.5 py-1 rounded-full whitespace-nowrap">最近更新</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              最新更新的漫画
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {latestComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group flex gap-4 bg-background-100 rounded-xl p-4 hover:bg-background-100/80 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="w-20 h-28 flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 99漫画${categoryLabels[comic.category]}最新章节`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="flex flex-col justify-between py-0.5 min-w-0">
                <div>
                  <h3 className="font-medium text-sm text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">
                    {categoryLabels[comic.category]} · {comic.author}
                  </p>
                </div>
                <div>
                  <div className="flex items-center gap-1 text-accent-500 text-xs">
                    <i className="ri-star-fill text-[10px]"></i>
                    <span className="font-medium">{comic.rating}</span>
                  </div>
                  <div className="flex items-center gap-3 mt-1.5">
                    <span className="text-[10px] text-foreground-400 whitespace-nowrap">
                      更新至{comic.chapters}话
                    </span>
                    {comic.isNew && (
                      <span className="px-1.5 py-0.5 bg-accent-100 text-accent-700 rounded text-[10px] font-medium whitespace-nowrap">
                        NEW
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}